module.exports = __webpack_public_path__ + "catalog/items/livingroom/Sofa/sofa.svg";